import React from 'react';
import './ParlayRole.css';

function PreviewParlayRole({ 
  matchDetails, 
  selectedOptions, 
  amount, 
  totalOdds, 
  potentialWin,
  onEdit,
  onConfirm,
  onGoBack
}) {
  return (
    <div className="parlay-role-page preview-mode">
      <div className="parlay-header">
        <button className="back-button" onClick={onGoBack}>
          <span>←</span>
        </button>
        <h1 className="page-title">Parlay Role</h1>
      </div>

      <div className="parlay-content">
        <div className="match-header">
          <div className="teams-vs-container">
            <span className="team-name-preview">{matchDetails.team1}</span>
            <span className="vs-text">VS</span>
            <span className="team-name-preview">{matchDetails.team2}</span>
          </div>
        </div>

        <div className="bet-amount">
          <span>Stake Amount:</span>
          <span className="amount">₹{amount || 'N/A'}</span>
        </div>

        <div className="preview-selected-options">
          <h2 className="section-title">Your Selected Options</h2>
          <div className="selected-options-list">
            {selectedOptions.map((option, index) => (
              <div key={option.id} className="selected-option-item">
                <span className="option-number">{index + 1}.</span>
                <span className="option-label">{option.label}</span>
                <span className="option-odds">{option.odds}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="parlay-summary">
          <h2 className="section-title">Parlay Summary</h2>
          <div className="summary-content">
            <div className="summary-item">
              <span>Selected Options:</span>
              <span>{selectedOptions.length}</span>
            </div>
            <div className="summary-item">
              <span>Total Odds:</span>
              <span>{totalOdds}</span>
            </div>
            <div className="summary-item">
              <span>Stake Amount:</span>
              <span>₹{amount}</span>
            </div>
            <div className="summary-item">
              <span>Potential Winnings:</span>
              <span>₹{potentialWin}</span>
            </div>
          </div>
          
          <div className="preview-actions">
            <button className="edit-selections-button" onClick={onEdit}>
              Edit Selections
            </button>
            <button className="confirm-parlay-button" onClick={onConfirm}>
              Submit Parlay
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PreviewParlayRole; 